import { render, staticRenderFns } from "./OptimaCategorySelect.vue?vue&type=template&id=30b0d1f4&scoped=true&"
import script from "./OptimaCategorySelect.vue?vue&type=script&lang=js&"
export * from "./OptimaCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b0d1f4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b0d1f4')) {
      api.createRecord('30b0d1f4', component.options)
    } else {
      api.reload('30b0d1f4', component.options)
    }
    module.hot.accept("./OptimaCategorySelect.vue?vue&type=template&id=30b0d1f4&scoped=true&", function () {
      api.rerender('30b0d1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomInputComponents/OptimaCategorySelect.vue"
export default component.exports